import NextCone from "../components/next-cone/prototypeView";
import CdnComponent from "../components/cdn-component/prototypeView";
import Iframe from "../components/iframe/prototypeView";
export default [NextCone, CdnComponent, Iframe];